import React from 'react';
import { useApp } from '../context/AppContext';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Badge } from '../components/ui/badge';
import CoachTab from '../components/ai/CoachTab';
import ChatbotTab from '../components/ai/ChatbotTab';
import FoodScannerTab from '../components/ai/FoodScannerTab';
import { Dumbbell, Bot, ScanLine, Sparkles, Infinity as InfinityIcon } from 'lucide-react';

export default function AIHubPage() {
  const { t } = useApp();

  return (
    <div className="max-w-3xl mx-auto px-3 sm:px-4 py-4">
      <div className="relative rounded-xl border border-border bg-card p-5 mb-5 overflow-hidden">
        <div className="absolute inset-0 hero-sheen pointer-events-none" />
        <div className="relative flex items-center gap-3">
          <div className="w-11 h-11 rounded-xl bg-[hsl(205,100%,56%)]/15 glow-ai flex items-center justify-center">
            <Sparkles size={22} className="text-[hsl(205,100%,56%)]" />
          </div>
          <div>
            <h1 className="text-xl font-semibold" style={{ fontFamily: 'Space Grotesk' }}>{t('aiHub')}</h1>
            <p className="text-xs text-muted-foreground">AI Coach · Chatbot · Food Scanner — powered by AI</p>
          </div>
        </div>
      </div>

      <Tabs defaultValue="coach" data-testid="ai-hub-tabs">
        <TabsList className="w-full grid grid-cols-3 mb-5">
          <TabsTrigger data-testid="ai-tab-coach" value="coach" className="gap-1.5 data-[state=active]:text-primary">
            <Dumbbell size={15} /> {t('aiCoach')}
          </TabsTrigger>
          <TabsTrigger data-testid="ai-tab-chatbot" value="chatbot" className="gap-1.5 data-[state=active]:text-[hsl(205,100%,56%)]">
            <Bot size={15} /> {t('aiChatbot')}
            <Badge data-testid="ai-chatbot-question-counter" variant="outline" className="ms-1 text-[10px] border-[hsl(205,100%,56%)]/40 text-[hsl(205,100%,56%)] px-1">
              <InfinityIcon size={11} />
            </Badge>
          </TabsTrigger>
          <TabsTrigger data-testid="ai-tab-food" value="food" className="gap-1.5 data-[state=active]:text-[hsl(205,100%,56%)]">
            <ScanLine size={15} /> {t('foodScanner')}
          </TabsTrigger>
        </TabsList>

        <TabsContent value="coach"><CoachTab /></TabsContent>
        <TabsContent value="chatbot"><ChatbotTab /></TabsContent>
        <TabsContent value="food"><FoodScannerTab /></TabsContent>
      </Tabs>
    </div>
  );
}
